import React from "react"
import { InspectionContext } from "../../context"
import { Form as FormType } from "../../models/new/forms.types"

type TProps = {
  children: React.ReactNode
}

const InspectionProvider = (props: TProps) => {
  const [inspectionForms, setInspectionForms] = React.useState<undefined | FormType[]>(undefined)

  return (
    <React.Fragment>
      <InspectionContext.Provider
        value={{
          inspectionForms,
          setInspectionForms,
        }}
      >
        {props.children}
      </InspectionContext.Provider>
    </React.Fragment>
  )
}

export default InspectionProvider
